import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
import Button from "../../../../component/Button/Button";
import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";
import Imageurldata from "../../../../Imageurldata";
import config from "../../../../config/config";

const FindStoreBanner = () => {
  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [titleErr, setTitleErr] = useState("");
  const [subtitleErr, setSubtitleErr] = useState("");

  const [leftImage, setLeftImage] = useState("");
  const [rightImage, setRightImage] = useState("");
  const [topImage, setTopImage] = useState("");
  const [bottomImage, setBottomImage] = useState("");

  const [leftErr, setLeftErr] = useState("");
  const [rightErr, setRightErr] = useState("");
  const [topErr, setTopErr] = useState("");
  const [bottomErr, setBottomErr] = useState("");

  const [leftPreview, setLeftPreview] = useState("");
  const [rightPreview, setRightPreview] = useState("");
  const [topPreview, setTopPreview] = useState("");
  const [bottomPreview, setBottomPreview] = useState("");

  const [leftNew, setLeftNew] = useState(false);
  const [rightNew, setRightNew] = useState(false);
  const [topNew, setTopNew] = useState(false);
  const [bottomNew, setBottomNew] = useState(false);

  const [bannerId, setBannerId] = useState(""); // for update
  const [toastlist, setToastList] = useState([]);

  const allowedTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];

  const showToast = (type, msg) => {
    const id = Math.floor(Math.random() * 101);
    let toastProperties = {};

    if (type === "success") {
      toastProperties = {
        id,
        title: "Success",
        description: msg || "Banner Saved Successfully",
        backgroundColor: "#329F33",
        icon: check,
      };
    } else {
      toastProperties = {
        id,
        title: "Error",
        description: msg || "Something went wrong",
        backgroundColor: "red",
        icon: close,
      };
    }

    setToastList([...toastlist, toastProperties]);
  };

  const validateImage = (file) => {
    if (!allowedTypes.includes(file.type)) {
      return "*Only JPG, PNG, WEBP images are allowed.";
    }
    return "";
  };

  const fetchBanner = () => {
    setLoading(true);
    axios
      .get(`${config.api_url}homepage/redbanner`)
      .then((res) => {
        const data = res.data[0]; // only one banner allowed
        if (data) {
          setBannerId(data._id);
          setTitle(data.title || "");
          setSubtitle(data.subtitle || "");
          setLeftImage(data.leftImage ? Imageurldata + data.leftImage : "");
          setRightImage(data.rightImage ? Imageurldata + data.rightImage : "");
          setTopImage(data.topImage ? Imageurldata + data.topImage : "");
          setBottomImage(
            data.bottomImage ? Imageurldata + data.bottomImage : ""
          );

          setLeftPreview(data.leftImage ? Imageurldata + data.leftImage : "");
          setRightPreview(
            data.rightImage ? Imageurldata + data.rightImage : ""
          );
          setTopPreview(data.topImage ? Imageurldata + data.topImage : "");
          setBottomPreview(
            data.bottomImage ? Imageurldata + data.bottomImage : ""
          );
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchBanner();
  }, []);

  const submit = () => {
    let valid = true;
    if (!title) {
      setTitleErr("*Please enter title.");
      valid = false;
    } else setTitleErr("");

    if (!subtitle) {
      setSubtitleErr("*Please enter subtitle.");
      valid = false;
    } else setSubtitleErr("");

    if (!leftImage) {
      setLeftErr("*Please upload left image.");
      valid = false;
    } else setLeftErr("");

    if (!rightImage) {
      setRightErr("*Please upload right image.");
      valid = false;
    } else setRightErr("");

    if (!topImage) {
      setTopErr("*Please upload top image.");
      valid = false;
    } else setTopErr("");

    if (!bottomImage) {
      setBottomErr("*Please upload bottom image.");
      valid = false;
    } else setBottomErr("");

    if (!valid) return;

    const formData = new FormData();
    formData.append("title", title);
    formData.append("subtitle", subtitle);

    if (leftNew) formData.append("leftImage", leftImage);
    if (rightNew) formData.append("rightImage", rightImage);
    if (topNew) formData.append("topImage", topImage);
    if (bottomNew) formData.append("bottomImage", bottomImage);

    const url = bannerId
      ? `${config.api_url}homepage/redbanner/update`
      : `${config.api_url}homepage/redbanner/new`;

    if (bannerId) formData.append("id", bannerId);

    setLoading(true);
    axios
      .post(url, formData)
      .then((res) => {
        showToast("success", bannerId ? "Banner Updated" : "Banner Added");
        fetchBanner();
        setLeftNew(false);
        setRightNew(false);
        setTopNew(false);
        setBottomNew(false);
        setLoading(false);
      })
      .catch((err) => {
        const msg =
          err.response?.data?.error || "Something went wrong while saving";
        showToast("error", msg);
        setLoading(false);
      });
  };

  const renderImageInput = (
    label,
    desc,
    file,
    preview,
    setFile,
    setPreview,
    setNewFlag,
    err,
    setErr
  ) => {
    const inputId = label.replace(/\s+/g, "_"); // unique id

    return (
      <>
        <Col lg={3} className="column">
          <div className="title">{label}</div>
          {desc && <div className="desc">{desc}</div>}
        </Col>
        <Col lg={9} className="column">
          <input
            type="file"
            id={inputId}
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0];
              if (!file) return;

              const error = validateImage(file);
              if (error) {
                setErr(error);
                return;
              }

              setErr("");
              setFile(file);
              setPreview(URL.createObjectURL(file));
              setNewFlag(true);
            }}
          />
          <label htmlFor={inputId} className="d-f" id="file-drag">
            <img src={upload} className="img-fluid" />
            <div className="chooseTxt">Choose File</div>
          </label>
          <div className="err">{err}</div>
          {preview && (
            <img
              src={preview}
              style={{ width: "100px", height: "100px", marginTop: "10px" }}
            />
          )}
        </Col>
      </>
    );
  };

  return (
    <>
      <h1>Find a Store Banner</h1>
      <Row className="adminhomeaboutSec1">
        {/* Title */}
        <Col lg={3} className="column">
          <div className="title">Title</div>
          <div className="desc text-muted">Recommended: up to 35 characters</div>
        </Col>
        <Col lg={9} className="column">
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="form-control"
          />
          <div className="err">{titleErr}</div>
        </Col>

        {/* Subtitle */}
        <Col lg={3} className="column">
          <div className="title">Subtitle</div>
          <div className="desc text-muted">Recommended: up to 60 characters</div>
        </Col>
        <Col lg={9} className="column">
          <textarea
            rows={4}
            value={subtitle}
            onChange={(e) => setSubtitle(e.target.value)}
            className="form-control"
          />
          <div className="err">{subtitleErr}</div>
        </Col>

        {/* Images */}
        {renderImageInput(
          "Desktop Left Image",
          "Recommended: 219 × 420 px",
          leftImage,
          leftPreview,
          setLeftImage,
          setLeftPreview,
          setLeftNew,
          leftErr,
          setLeftErr
        )}

        {renderImageInput(
          "Desktop Right Image",
          "Recommended: 274 × 416 px",
          rightImage,
          rightPreview,
          setRightImage,
          setRightPreview,
          setRightNew,
          rightErr,
          setRightErr
        )}

        {renderImageInput(
          "Mobile Top Image",
          "Recommended: 297 × 158 px",
          topImage,
          topPreview,
          setTopImage,
          setTopPreview,
          setTopNew,
          topErr,
          setTopErr
        )}

        {renderImageInput(
          "Mobile Bottom Image",
          "Recommended: 256 × 166 px",
          bottomImage,
          bottomPreview,
          setBottomImage,
          setBottomPreview,
          setBottomNew,
          bottomErr,
          setBottomErr
        )}

        <Col className="column d-f j-c a-c mt-4">
          <Button onClick={submit} title={bannerId ? "UPDATE" : "ADD"} />
        </Col>
      </Row>

      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default FindStoreBanner;
